/**
 * Persistência de eventos enviados via beacon no unload (recovery na próxima sessão).
 */

import type { QueueItem } from './queue';

const PENDING_UNLOAD_KEY = 'GOMARKE_PENDING_UNLOAD_V1';

export function persistPendingUnloadItems(items: QueueItem[]): void {
  if (typeof window === 'undefined' || items.length === 0) return;
  try {
    const existing = loadPendingUnloadItems();
    window.localStorage.setItem(
      PENDING_UNLOAD_KEY,
      JSON.stringify([...existing, ...items])
    );
  } catch {
    // quota
  }
}

export function loadPendingUnloadItems(): QueueItem[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(PENDING_UNLOAD_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as QueueItem[]) : [];
  } catch {
    return [];
  }
}

export function clearPendingUnloadItems(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(PENDING_UNLOAD_KEY);
  } catch {
    // ignore
  }
}

export function removePendingUnloadByIds(ids: Set<string>): void {
  const remaining = loadPendingUnloadItems().filter(i => !ids.has(i.id));
  if (typeof window === 'undefined') return;
  try {
    if (remaining.length === 0) {
      clearPendingUnloadItems();
    } else {
      window.localStorage.setItem(PENDING_UNLOAD_KEY, JSON.stringify(remaining));
    }
  } catch {
    // ignore
  }
}
